<script>
export default {
  name: "DidoCatalogBreadcrumb",
};
</script>

<script setup>
import { computed } from "vue";
import breadcrumbArrow from "../../assets/breadcrumb-arrow.png";

// define Props
const props = defineProps({
  pageInfos: { type: Object, required: true },
});

// define events emitted
const emit = defineEmits(["breadcrumb-click"]);

const firstLinks = computed(() => {
  const firstItems = [];
  if (props.pageInfos.websitePage)
    firstItems.push({
      label: "Accueil",
      href: props.pageInfos.websitePage,
    });
  if (props.pageInfos.landingPage)
    firstItems.push({
      label: "DiDo",
      href: props.pageInfos.landingPage,
    });
  return firstItems;
});

const links = computed(() => {
  if (props.pageInfos.page === "500") {
    return [
      {
        label: "Explorer le catalogue",
        href: props.pageInfos.exploreUrl,
        page: "DidoExplore",
      },
      {
        label: "Serveur indisponible",
        href: null,
        page: null,
      },
    ];
  }

  if (props.pageInfos.page === "404") {
    return [
      {
        label: "Explorer le catalogue",
        href: props.pageInfos.exploreUrl,
        page: "DidoExplore",
      },
      {
        label: "Page inexistante",
        href: null,
        page: null,
      },
    ];
  }

  if (props.pageInfos.page === "apidoc") {
    return [
      {
        label: "Documentation API",
        href: null,
        page: null,
      },
    ];
  }

  if (props.pageInfos.page === "explore") {
    return [
      {
        label: "Explorer le catalogue",
        href: null,
        page: null,
      },
    ];
  }

  if (props.pageInfos.page === "dataset") {
    return [
      {
        label: "Explorer le catalogue",
        href: props.pageInfos.exploreUrl,
        page: "DidoExplore",
      },
      {
        label: "Page jeu de données",
        href: null,
        page: null,
      },
    ];
  }

  if (props.pageInfos.page === "datafile") {
    return [
      {
        label: "Explorer le catalogue",
        href: props.pageInfos.exploreUrl,
        page: "DidoExplore",
      },
      {
        label: "Page jeu de données",
        href: props.pageInfos.datasetUrl,
        page: "DidoDatasetDetail",
      },
      {
        label: "Page fichier de données",
        href: null,
        page: null,
      },
    ];
  }

  return [];
});
</script>

<template>
  <QBreadcrumbs
    class="dido-breadcrumb"
    color="black"
    active-color="black"
    gutter="xs"
  >
    <template #separator>
      <img :src="breadcrumbArrow" alt="breadcrumb_separator" />
    </template>
    <QBreadcrumbsEl
      v-for="(link, index) of firstLinks"
      :key="`breadcrumb-firstlink-${index}`"
      :label="link.label"
      tag="a"
      :href="link.href"
      class="dido-breadcrumd-el"
    />
    <template v-for="(link, index) of links" :key="`breadcrumb-link-${index}`">
      <QBreadcrumbsEl
        v-if="link.href"
        :label="link.label"
        tag="a"
        :href="link.href"
        class="dido-breadcrumd-el"
        @click.prevent="
          emit('breadcrumb-click', { page: link.page, url: link.href })
        "
      />
      <QBreadcrumbsEl
        v-else
        :label="link.label"
        tag="span"
        class="dido-breadcrumd-el"
      />
    </template>
  </QBreadcrumbs>
</template>

<style lang="sass" scoped>
.dido-breadcrumb
  :deep( a:hover)
    text-decoration: underline
</style>
